<template>
  <ORow shrink-1 right style="width: auto">
    Pend. ticket:
    <v-btn color="error" class="mx-2" @click="$emit('click:pendingTicket')">
      {{ stats.pctProblemsAndNoTicket | pct }}
    </v-btn>

    Pend. checklist:
    <v-btn color="amber" class="mx-2" @click="$emit('click:pendingChecklist')">
      {{ stats.pctPendingChecklists | pct }}
    </v-btn>
  </ORow>
</template>

<script>
export default {
  props: {
    stats: { required: true }
  },
  methods: {},
  filters: {
    pct(x) {
      if (x != null) {
        return Math.floor(x * 100) + '%'
      } else {
        return '─'
      }
    }
  }
}
</script>

<style></style>
